export default {
  env: 'staging',
  apiBaseUrl: 'https://api.cb.c7m.io',
  salesEdgeBaseUrl: 'https://sales-backend-api.cb.c7m.io',
  salesEdgeRedirectUrl: 'https://sales.cb.c7m.io',
  salesforceReauthUrl: 'lightning/n/xbqa__Setup',
  host: 'app.cb.c7m.io',
  appcuesEnabled: true,
  postHog: null,
  auth0: {
    domain: 'auth.cb.c7m.io',
    clientID: 'zpqyu12qLqNke407hhYK93bQ2nZRGA5l',
    audience: 'https://api.staging.getcrossbeam.com',
  },
  dash0: {
    serviceName: 'crossbeam-web',
    environment: 'staging',
    endpoint: {
      url: 'https://ingress.us-west-2.aws.dash0.com',
      authToken: 'auth_BQNcQ94FlrU49CBgwX8g8j0mR37IP45L',
    },
    propagators: [
      { type: 'traceparent', match: [/^https:\/\/api\.cb\.c7m\.io/] },
    ],
  },
  statuspageBaseUrl: 'https://crossbeamstaging.statuspage.io',
  statuspagePageId: '6dcrv6nnlbkg',
  statusPageEmbedUrl: 'https://6dcrv6nnlbkg.statuspage.io/embed/script.js',
  enableGoogleTags: true,
  googleTagManagerId: 'GTM-5KBK2WD',
  intercom: {
    enabled: true,
    workspaceId: 'g42wpi5b',
  },
  userLeap: {
    enabled: true,
    appId: '6pBot6YECBQ',
  },
  iteratively: {
    environment: 'development',
  },
  hubSpotForms: {
    contactSalesForm: '846e4458-a3ea-42a4-ae97-f148221fd56b',
    envID: '5767578',
  },
  chargify: {
    publicKey: 'chjs_qq34qvgz5d523d87w8hv7fdz',
    serverHost: 'https://crossbeam-stage.chargify.com',
  },
  liveRampTagId: '713285',
  agentBaseUrl: 'https://agent.cb.c7m.io',
  aiChatHost: 'agent.cb.c7m.io',
  logoDevPublicKey: 'pk_JzJ-unVJSx6Zd7MX1uKUog',
} as const;
